import {di, lazyRun} from "@dp-instant/core";
import {TypesSocial} from "@dp-instant/interfaces";

/**
 * @see https://docs.unity3d.com/ScriptReference/PlayerPrefs.html
 */
const PLAYER_PREFS_KEY = "homo-evolution-player-prefs";
let PLAYER_PREFS_DATA = null;
let resetRequested = false;

export class PlayerPrefs {
    #cookie = di.get(TypesSocial.cookie);

    static async Load() {
        try {
            // let data = await FBInstant.player.getDataAsync([PLAYER_PREFS_KEY]);
            const cookie = await di.get(TypesSocial.cookie);
            let data = await cookie.get([PLAYER_PREFS_KEY]);
            PLAYER_PREFS_DATA = data ? data[PLAYER_PREFS_KEY] : null;
        } catch (e) {
            console.log("PREFS LOAD ERROR", e);
            PLAYER_PREFS_DATA = null;
        }
    }

    /**
     * Writes all modified preferences to disk.
     */
    static async Save() {
        if (resetRequested) return;
        try {
            const cookie = di.get(TypesSocial.cookie);
            await cookie.save(PLAYER_PREFS_KEY, PLAYER_PREFS_DATA);
            //await cookie.write(PLAYER_PREFS_KEY);
            // await FBInstant.player.setDataAsync({
            //     [PLAYER_PREFS_KEY]: PLAYER_PREFS_DATA || null
            // });
        } catch (e) {
            console.log("PREFS SAVE ERROR", e);
        }
    }

    static Reset() {
        this.DeleteAll();
        resetRequested = true;
    }

    /**
     * Removes all keys and values from the preferences. Use with caution.
     */
    static DeleteAll() {
        PLAYER_PREFS_DATA = null;
        this.Save();
    }

    /**
     * Removes the given key from the PlayerPrefs. If the key does not exist, DeleteKey has no impact.
     */
    static DeleteKey(key) {
        if (!this.HasKey(key)) return;
        delete PLAYER_PREFS_DATA[key];
        this.Save();
    }

    static _getItem(key, defaultValue) {
        if (!this.HasKey(key)) return defaultValue;
        return PLAYER_PREFS_DATA[key];
    }

    /**
     * Returns the value corresponding to key in the preference file if it exists.
     */
    static GetFloat(key, defaultValue) {
        if (!this.HasKey(key)) return defaultValue;
        return parseFloat(this._getItem(key));
    }

    /**
     * Returns the value corresponding to key in the preference file if it exists.
     */
    static GetInt(key, defaultValue) {
        if (!this.HasKey(key)) return defaultValue;
        return parseInt(this._getItem(key));
    }

    /**
     * Returns the value corresponding to key in the preference file if it exists.
     */
    static GetString(key, defaultValue) {
        if (!this.HasKey(key)) return defaultValue;
        return String(this._getItem(key));
    }

    /**
     * Returns true if the given key exists in PlayerPrefs, otherwise returns false.
     */
    static HasKey(key) {
        return PLAYER_PREFS_DATA && PLAYER_PREFS_DATA.hasOwnProperty(key);
    }

    static _setItem(key, value) {
        PLAYER_PREFS_DATA = PLAYER_PREFS_DATA || {};
        PLAYER_PREFS_DATA[key] = value;
        this.Save();
    }

    /**
     * Sets the float value of the preference identified by the given key. You can use PlayerPrefs.GetFloat to retrieve this value.
     */
    static SetFloat(key, value) {
        this._setItem(key, parseFloat(value));
    }

    /**
     * Sets a single integer value for the preference identified by the given key. You can use PlayerPrefs.GetInt to retrieve this value.
     */
    static SetInt(key, value) {
        this._setItem(key, parseInt(value));
    }

    /**
     * Sets a single string value for the preference identified by the given key. You can use PlayerPrefs.GetString to retrieve this value.
     */
    static SetString(key, value) {
        this._setItem(key, String(value));
    }
}
